export class EntityConverter {
  static toDbo(source: any): any {

    var body = {
      attributes: {
        name: [source.layer.name ? source.layer.name : ''],
        description: [source.layer.description ? source.layer.description : ''],
        geometry: [
          {
            type: source.layerType == 'marker' ? 'Point' : source.layerType == 'polyline' ? 'LineString' : 'Polygon',
            coordinates: []
          }
        ]
      }
    };
    if (source.layerType == 'marker') {
      body.attributes.geometry[0].coordinates.push(source.layer._latlng['lng'], source.layer._latlng['lat']);
    }
    else {
      source.layer._latlngs.forEach((element, index) => {
        if (element.length > 0) {
          var coords = [];
          element.forEach(e => {
            coords.push([e.lng, e.lat]);
          })
          if (source.layerType == 'polygon') {
            coords.push([element[0].lng, element[0].lat]);
          }

          body.attributes.geometry[0].coordinates.push(coords);
        }
        else {
          body.attributes.geometry[0].coordinates.push([element.lng, element.lat]);
        }
      });
    }

    return body;
  }

  static toDboForUpdate(source: any): any {
    return {
    }
  }


  static toUiMReport(source: any): any {
    return {
    }
  }
}
